import { render, staticRenderFns } from "./postComment.vue?vue&type=template&id=702cbe69&lang=pug&"
import script from "./postComment.vue?vue&type=script&lang=js&"
export * from "./postComment.vue?vue&type=script&lang=js&"
import style0 from "./postComment.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "postComment.vue"
export default component.exports